export const enum IdentificationMedia {
    BADGE = 'BADGE',
    LICENSE_PLATE = 'LICENSE_PLATE',
    QR_CODE = 'QR_CODE',
    TICKET = 'TICKET',
    SPACE = 'SPACE',
}
